import type { MessageKey } from 'types/LocaleMessageKey';

interface HeartHealthTestimonial {
  id: string;
  image: {
    alt: MessageKey;
    src: string;
  };
  name: string;
  quote: MessageKey;
  tag: MessageKey;
}

const heartHealthTestimonials: HeartHealthTestimonial[] = [
  {
    id: 'dave-k',
    image: {
      alt: 'testimonial_dave_k_alt',
      src: 'blue-sky/heart-health/testimonials-dave-k',
    },
    name: 'Dave K.',
    quote: 'heart_health_testimonial_quote_dave_k',
    tag: 'pdp_heart_rate',
  },
  {
    id: 'anne',
    image: {
      alt: 'testimonial_anne_alt',
      src: 'blue-sky/heart-health/testimonials-anne',
    },
    name: 'Anne',
    quote: 'heart_health_testimonial_quote_anne',
    tag: 'heart_health_tag',
  },
  {
    id: 'ted-n',
    image: {
      alt: 'testimonial_ted_n_alt',
      src: 'blue-sky/heart-health/testimonials-ted-n',
    },
    name: 'Ted N.',
    quote: 'heart_health_testimonial_quote_ted_n',
    tag: 'pdp_heart_rate',
  },
];

export default heartHealthTestimonials;
